import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.18 5 8.59 15.579 4.42 11.41 3 12.82l5.59 5.59 11.999-12L19.18 5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol